export default __webpack_public_path__ + "static/MediaContentFour-c74f2cfdd6df67d52f37f901377f3dff.webp";